import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=79e0dc1a&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=ts&"
export * from "./CardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0dc1a",
  null
  
)

export default component.exports